var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcArrowDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 27"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 21",
    style: {
      fill: "none"
    },
    d: "M0 0h12v12H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 19",
    d: "M5.469 6.458a.986.986 0 0 1-.7-.29L.29 1.689a.989.989 0 0 1 1.4-1.4l3.78 3.78L9.25.29a.989.989 0 0 1 1.4 1.4L6.169 6.168a.986.986 0 0 1-.7.29",
    transform: "translate(.288 2.476)",
    style: {
      fill: "#00a61c"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowDown);
export default __webpack_public_path__ + "static/media/ic-arrow-down.9fe5b06dead33799b30feb2a19096ba8.svg";
export { ForwardRef as ReactComponent };